import { useState } from "react";
import { faqs } from "@/mocks/events";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section className="w-full bg-background-100">
      <div className="container-x py-14 md:py-20">
        <div className="max-w-2xl">
          <span className="eyebrow">
            <i className="ri-question-line" aria-hidden="true" />
            常见问题
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            关于吃瓜爆网，你可能想知道
          </h2>
          <p className="mt-4 text-[15px] leading-7 text-foreground-700">
            我们如何追踪走红事件、如何保证内容客观、多久更新一次？以下回答希望能帮你快速了解我们。
          </p>
        </div>

        <div className="mt-10 space-y-3 md:mt-12">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  open ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-50/60"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className={`font-label text-[15px] font-medium ${open ? "text-primary-700" : "text-foreground-950"}`}>
                    {f.q}
                  </span>
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border text-sm transition-all duration-200 ${
                      open ? "rotate-180 border-primary-400 text-primary-600" : "border-background-300 text-foreground-600"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line" aria-hidden="true" />
                  </span>
                </button>
                <div className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-7 text-foreground-700">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}